module.exports = "/_next/static/media/avatar-cloud.30efaceb.png";